// extracted by mini-css-extract-plugin
export var body = "_ij-8";
export var button = "_ij-0";
export var closeButton = "_ij-5";
export var content = "_ij-3";
export var empty = "_ij-f";
export var grid = "_ij-c";
export var header = "_ij-4";
export var icon = "_ij-1";
export var option = "_ij-d";
export var optionSelected = "_ij-e";
export var overlay = "_ij-2";
export var searchIcon = "_ij-a";
export var searchInput = "_ij-b";
export var searchWrapper = "_ij-9";
export var title = "_ij-6";
export var visuallyHidden = "_ij-7";